import { useCallback } from "react"
import { connect } from "react-redux"
import { Download } from "lucide-react"
import { closeMainModal, openMainModal } from "../../../../store/actions"
import { useActionGuard } from "../../../../hooks/useActionGuard.ts"
import { fireAnalytics } from "../../../../utils/firebase"
import {
  saveEstimationCostPdf,
  type EstimationPdfMaterialRow,
} from "../../../../utils/estimationPdfExport.ts"
import type { UserData } from "../../../../types/calculadoraDeMateriales.ts"
import downloadBtnStyles from "../DownloadPdfButton.module.scss"

type OpenMainModal = (opts: {
  title: string
  body: string
  iconType: string
  isSuccess?: boolean
  dismiss?: boolean
  yesLabel?: string
  noLabel?: string
  confirmHandler?: (() => void) | null
  customCloseMainModal?: () => void
}) => void

type EstimationDownloadActionsProps = {
  materials: EstimationPdfMaterialRow[]
  setShowSendQuotePopup: (v: boolean) => void
  openMainModal: OpenMainModal
  closeMainModal: () => void
  previewPopUp?: boolean
  closePreview?: () => void
  userData?: UserData | null
  className?: string
}

const EstimationDownloadActions = ({
  materials,
  setShowSendQuotePopup,
  openMainModal,
  closeMainModal,
  previewPopUp,
  closePreview,
  userData,
  className,
}: EstimationDownloadActionsProps) => {
  const { guard } = useActionGuard()

  const handleDownload = useCallback(async () => {
    await saveEstimationCostPdf(materials)
  }, [materials])

  const handleDownloadModal = guard("download_pdf", () => {
    openMainModal({
      title: "Descargar estimación de costos",
      body: "¿Sabías que además de descargar el PDF, puedes enviar la cotización a los proveedores para que te envíen sus ofertas?",
      iconType: "warning",
      dismiss: true,
      yesLabel: "Enviar para cotizar",
      noLabel: "Descargar PDF",
      confirmHandler: () => {
        closeMainModal()
        setShowSendQuotePopup(true)
      },
      customCloseMainModal: () => {
        if (previewPopUp) {
          closePreview?.()
        }
        closeMainModal()
        fireAnalytics("download_estimacion_de_costos", { user_info_estimacion: userData?.id })
        void handleDownload()
      },
    })
  })

  const pdfButtonClass = `${downloadBtnStyles["download-btn"]} ${previewPopUp ? downloadBtnStyles["preview-btn"] : ""} ${className || ""}`.trim()

  return (
    <button
      type="button"
      className={pdfButtonClass}
      onClick={guard("download_pdf", handleDownloadModal, () =>
        fireAnalytics("download_estimacion_de_costos", { user_info_estimacion: userData?.id })
      )}
      disabled={materials.length === 0}
    >
      <Download
        style={{ minHeight: "1.6rem", maxHeight: "1.6rem", minWidth: "1.6rem", maxWidth: "1.6rem" }}
      />
      <span>Descargar estimación</span>
    </button>
  )
}

export default connect(null, { openMainModal, closeMainModal })(EstimationDownloadActions)
